import React from 'react';
import { connect } from 'react-redux';
import TranslatedCopy from '../../intl/translated-copy';
import PropTypes from 'prop-types';
import Btn from '../global/button';
import {
  changeCorporateFlow,
  closeModalCorporate,
  openModalCorporate,
  setChangeCorporateCompany,
  setCompanySelected,
  setCorporateSupplierSelected,
  setFlowCorporateIsActive,
  setSwitchFlowCorporateIsActive,
  updateShoppingCart,
} from '../../../redux/actions/index';
import { deleteCookie } from '../../utilities/helpers';
import { sendAnalytics } from '../../../scripts/analytics/tracker';
import manageTracking from '../../../scripts/analytics/creators/manage';
import { trackCorpToReg } from '../../../scripts/analytics/creators/corporate';

const imagesInit = {
  alert: require('../../../images/corporate/modal-profile-corporate-alert.png'),
};

const mapStateToProps = state => ({
  user: state.UserProfileSession,
  userCorporate: state.Corporate.userCorporate,
  pnrInfo: state.Manage.pnrInfo,
  storeFront: state.Manage.storefront,
});
const ModalProfileSwitchAlertCorporative = (props) => {
  const {
    ancillaryOfferCollectionModel,
    country,
    user,
    userCorporate,
    dispatch,
    isActiveFlowCorporate,
    language,
    onCloseModals,
    openCorporateModals,
    pnrInfo,
    pnrModel,
    storeFront,
    userToken,
  } = props;

  const corporateSwitchTitle = isActiveFlowCorporate ? 'CORPORATE_SWITCH_PROFILE_MODAL_TITLE' : 'Estás apunto de cambiar a tu perfil corporativo';
  const experienceSwitchLink = isActiveFlowCorporate ? 'CORPORATE_SWITCH_PROFILE_MODAL_LINK' : 'Cambiar a mi perfil corporativo';

  const isPaymentPoints = pnrModel?.cart?.total?.paymentCPPoints;
  const totalWithoutBase = pnrModel?.cart?.total?.totalWithoutBase;
  const totalPay = isPaymentPoints ? totalWithoutBase :  pnrModel?.cart?.total?.total;

  const renderModalHeader = (
    <section className='UserProfile-Corporate-switch-Header'>
      <img src={ imagesInit.alert }></img>
    </section>
  );

  const renderModalBody = (
    <section className='UserProfile-Corporate-switch-Body'>
      <TranslatedCopy
        className= 'UserProfile-Corporate-switch-Body-Red'
        copyID= 'CORPORATE_SWITCH_PROFILE_MODAL'
      />
      <TranslatedCopy
        className='UserProfile-Corporate-switch-Body-title'
        copyID={ corporateSwitchTitle }
      />
      <TranslatedCopy
        className='UserProfile-Corporate-switch-Body-Text'
        copyID='CORPORATE_SWITCH_PROFILE_MODAL_DESC_MYB'
      />
      <TranslatedCopy
        className='UserProfile-Corporate-switch-Body-Link'
        copyID={ experienceSwitchLink }
        onClick={ () => changeToPersonal() }
      />
      <Btn
        btnType='submit'
        copyID='CORPORATE_SWITCH_PROFILE_MODAL_BUTTON'
        filledRed={ true }
        onBtnClick={ () => handleCloseModal() }
        visuallyDisabled={ false }
      />
    </section>
  );

  openCorporateModals();

  function changeToPersonal() {
    const flowToChange = isActiveFlowCorporate;
    const supplier = isActiveFlowCorporate ? 'personal' : 'nutravel';
    const company = pnrModel?.corporateFlow?.companyName;
    const Companies = userCorporate?.companies?.companies;
    const changeActiveCompany = isActiveFlowCorporate ? '' : company;
    handleAncillariesUpgrade();
    handleCorpToPersonalMetric();
    dispatch(setFlowCorporateIsActive(!flowToChange));
    dispatch(changeCorporateFlow(false));
    dispatch(setCorporateSupplierSelected(supplier));
    dispatch(setCompanySelected( changeActiveCompany ));
    localStorage.removeItem('userCorporateCompany');
    localStorage.removeItem('userIsCorporate');
    localStorage.removeItem('userProfileCorporateFlow');

    if (isActiveFlowCorporate) {
      deleteCookie('userSessionCorporate');
      if (Companies.length > 0) {
        dispatch(setChangeCorporateCompany(false));
      } else {
        dispatch(closeModalCorporate());
      }
    } else {
      dispatch(openModalCorporate());
    }

    onCloseModals();
  }

  function handleCloseModal() {
    dispatch(changeCorporateFlow(false));
    dispatch(setSwitchFlowCorporateIsActive(false));
    onCloseModals();
  }

  function handleAncillariesUpgrade() {
    const travelersToRemove = pnrModel.cart.getAllPassengers();
    const noInfantTravelers = pnrModel.cart.getNonInfantTravelers();
    const segmentCodesUpsellOffers = pnrModel.getUpgradeAvailableSegmentsCodesArray();
    // Ancillary upgrade getAncillaryByType
    const ancillaryUpgradeModel = ancillaryOfferCollectionModel._ancillaries.filter(upgradeAncillary => {
      return upgradeAncillary?.ancillary?.type === 'UPG' && segmentCodesUpsellOffers?.includes(upgradeAncillary?.segmentCode);
    });
    ancillaryUpgradeModel.forEach((ancillary) => {
      travelersToRemove.forEach(travelerStatus => {
        const travelerToRemove = noInfantTravelers.find(traveler => traveler.id === travelerStatus.id);
        travelerToRemove.removeUpgradeAncillary(ancillary);
      });
    });
    pnrModel.cart.travelerCollection.map((travelerCollections, index) => {
      travelerCollections.ancillaries.ancillaries.map((subAncillaries, indice) => {
        if (subAncillaries?.ancillary?.commercialName === ('AM VUELA VERDE'
          || 'SEGURO DE VIAJES' || 'DISCOUNT PASS MEXICO' || 'AEROMEXICO CONCIERGE') || subAncillaries?.ancillary?.groupCode === 'BG'
          || subAncillaries.ancillary?.groupCode === '99' || subAncillaries?.ancillary?.groupCode === 'TS' || subAncillaries?.ancillary?.groupCode === 'SA') {
          pnrModel.cart.travelerCollection[index].ancillaries.ancillaries[indice].quantity = 0;
        }
      });
    });
    dispatch(setSwitchFlowCorporateIsActive(true));
    dispatch(updateShoppingCart(country, pnrModel.cart.cartId, language, pnrModel, false, null, userToken));
  }

  function handleCorpToPersonalMetric() {
    if (isActiveFlowCorporate) {
      dispatch(sendAnalytics({
        eventCreator: trackCorpToReg('Itinerary'),
      }));

      dispatch(sendAnalytics({
        eventCreator: manageTracking.trackuserPropertiesWeb(pnrInfo, user?.userProfile, 'Manage my Booking', storeFront, { isSwitchCorporate: false }),
      }));
    }
  }

  function BodyAlert() {
    let body = '';
    if ( totalPay > 0 ) {
      body = (
        <div className='modal-Corporate'>
          <div className='Modal-inner-Corporate'>
            <div className=' Modal-body--regular has-noDefaultTopBar' tabIndex='0'>
              <div className='UserProfile-Corporate-switch'>
                { renderModalHeader }
                { renderModalBody }
              </div>
            </div>
          </div>
        </div>);
    } else {
      changeToPersonal();
    }
    return body;
  }

  return (
    <BodyAlert />
  );
};

ModalProfileSwitchAlertCorporative.propTypes = {
  ancillaryOfferCollectionModel: PropTypes.object.isRequired,
  country: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  isActiveFlowCorporate: PropTypes.bool,
  language: PropTypes.string,
  onCloseModals: PropTypes.func.isRequired,
  openCorporateModals: PropTypes.func.isRequired,
  pnrModel: PropTypes.object.isRequired,
  userToken: PropTypes.string,
};

export default connect(mapStateToProps)(ModalProfileSwitchAlertCorporative);